import { useDispatch, useSelector } from "react-redux";
import {
  showFilterOverlay,
  showSortOverlay
} from "../../state/modules/layout/actions";
import { hasFacets } from "../../state/modules/search/selectors";
import { withTranslation } from "../../components/translation/";
import FilterAndSort from "../../components/FilterAndSort";

const ConnectedSmallFilterAndSort = props => {
  const dispatch = useDispatch();
  const facetsExist = useSelector(hasFacets);

  return (
    <FilterAndSort
      showFilterOverlay={() => dispatch(showFilterOverlay())}
      showSortOverlay={() => dispatch(showSortOverlay())}
      hasFacets={facetsExist}
      {...props}
    />
  );
};

export default withTranslation(ConnectedSmallFilterAndSort);
